import request from '@/utils/request';
import * as types from '@/api/common/types';

export function upload(data: types.commonReqType): Promise<types.commonResType> {
  return request({
    url: `/api/v1/upload`,
    method: 'post',
    data
  });
}

// 通过path获取组织/项目id等信息
export function getSourceInfo(params:{path: string}): Promise<any> {
  return request({
    url: `/api/v2/resource/${params.path}`,
    method: 'get'
  });
}

// 通过path获取仓库附件大小限制
export function getAttachmentQuota(params:{path: string}): Promise<any> {
  return request({
    url: `/api/v2/resource/projects/${params.path}/attachment_quota`,
    method: 'get'
  });
}

// 获取国家区域配置
export function getMobileMetadata() {
  return request({
    url: `/api/v1/user/mobile/metadata`,
    method: 'get'
  });
}

// 获取ToolBar背景图支持配置
export function getToolbarConfig() {
  return request({
    url: `/api/v1/search/common/config/toolbar`,
    method: 'get'
  });
}
